import classNames from 'classnames'
import React from 'react'
import { useFilterStore } from '../../state/filterStore'
import { mapStore } from '../../state/mapStore'
import * as UI from '@brewlogix/blx-ui'
import useMapFunctions from '../../utils/functions/useMapFunctions'

const FilterMapButtons: React.FC = () => {
    // Map Store
    const mapView = mapStore((state) => state.mapView)
    const activeTab = mapStore((state) => state.activeTab)
    const fullScreenShowFullMap = mapStore((state) => state.fullScreenShowFullMap)
    const setMapView = mapStore((state) => state.setMapView)
    const { map } = useMapFunctions()

    // Filter Store
    const setShowFiltersDrawer = useFilterStore((state) => state.setShowFiltersDrawer)
    const filterCount = useFilterStore((state) => state.filterCount)

    const containerClasses = classNames(
        'button__show-map w-full  rounded-xl  pt-4',
        mapView ? '' : 'relative',
        activeTab === 'routes' ? 'mb-1 px-[1.15rem] lg:px-4' : '-mb-1 px-4 lg:hidden',
        fullScreenShowFullMap ? '' : 'xl:hidden'
    )
    const filterButtonClasses = classNames(
        'h-10 p-2 flex justify-center items-center border-1 mobile-filter ml-2 lg:ml-auto lg:w-full',
        filterCount > 0 ? 'border-blue-300' : 'border-dark',
        fullScreenShowFullMap ? '' : 'xl:hidden',
        activeTab === 'routes' ? '' : 'lg:hidden'
    )
    const handleFilterMapButtonClick = () => {
        setMapView(!mapView)
        if (map.current) {
            map.current.resize()
        }
    }

    return (
        <div className={containerClasses}>
            <UI.Button
                onClick={handleFilterMapButtonClick}
                customClasses='flex justify-center items-center w-full py-0 lg:hidden'
                theme='dark'
                size='sm'
            >
                <UI.Icon
                    theme='light'
                    slug={mapView ? 'ListView' : 'HeroIcons.Map'}
                    customClasses='mr-2'
                />
                {mapView ? 'List' : 'Map'}
            </UI.Button>
            <UI.Button
                onClick={() => setShowFiltersDrawer(true)}
                customClasses={filterButtonClasses}
                theme={filterCount > 0 ? 'link' : 'default'}
                size='sm'
            >
                <UI.Icon slug='HeroIcons.Adjustments' customClasses='mr-1' theme='link' size='sm' />
                <span>Filter</span>
                {filterCount > 0 && (
                    <span className='ml-1 h-4 w-4 rounded-full bg-blue-300 text-xs text-light'>
                        {filterCount}
                    </span>
                )}
            </UI.Button>
        </div>
    )
}

export default FilterMapButtons
